var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_22446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.901733,
    width: 24,
    height: 24,
    fill: "#474758"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_22446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M20.25 22.3434L15.9458 18.0392C15.3417 18.5226 14.6469 18.9052 13.8615 19.1872C13.076 19.4691 12.2403 19.6101 11.3542 19.6101C9.15903 19.6101 7.30122 18.8498 5.78073 17.3293C4.26024 15.8089 3.5 13.951 3.5 11.7559C3.5 9.56076 4.26024 7.70295 5.78073 6.18246C7.30122 4.66198 9.15903 3.90173 11.3542 3.90173C13.5493 3.90173 15.4071 4.66198 16.9276 6.18246C18.4481 7.70295 19.2083 9.56076 19.2083 11.7559C19.2083 12.642 19.0674 13.4778 18.7854 14.2632C18.5035 15.0486 18.1208 15.7434 17.6375 16.3476L21.9417 20.6517L20.25 22.3434ZM11.3542 17.1934C12.8646 17.1934 14.1484 16.6648 15.2057 15.6075C16.263 14.5502 16.7917 13.2663 16.7917 11.7559C16.7917 10.2455 16.263 8.96163 15.2057 7.90434C14.1484 6.84705 12.8646 6.3184 11.3542 6.3184C9.84375 6.3184 8.5599 6.84705 7.5026 7.90434C6.44531 8.96163 5.91667 10.2455 5.91667 11.7559C5.91667 13.2663 6.44531 14.5502 7.5026 15.6075C8.5599 16.6648 9.84375 17.1934 11.3542 17.1934Z",
    fill: "#474758"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.0a1bbe8fbb1e472cf7862fee789a4bd3.svg";
export { ForwardRef as ReactComponent };